import React, {Component} from 'react';
import {InputNumber} from 'antd';
import './SAInputCurrency.css';
import FieldError from "./FieldError";


class SAInputCurrency extends Component {

  render() {
    const { error, className, name, onChange, placeholder, value, ...attributes } = this.props;

    return (
      <span className={className}>
        <InputNumber
                     name={name}
                     placeholder={placeholder}
                     value={value}
                     min={0}
                     precision={2}
                     step={10}
                     formatter={value => `${value}€`}
                     parser={value => value.replace('€', '')}
                     onChange={onChange}
                     {...attributes}
        />
        {error && (
          <FieldError error={error}/>
        )}
      </span>
    );
  }
}

export default SAInputCurrency;
